(() => {
  const hostSelector = 'etrusted-ps-popover';
  const mobileBreakpoint = 749;
  const gutter = 16;
  const observedRoots = new WeakSet();

  function alignPopover(root) {
    const popover = root.querySelector('.popover');
    if (!popover) return;

    const availableWidth = document.documentElement.clientWidth || window.innerWidth;
    const maxWidth = `${Math.max(0, availableWidth - gutter * 2)}px`;

    if (popover.style.getPropertyValue('max-width') !== maxWidth) {
      popover.style.setProperty('max-width', maxWidth, 'important');
    }
    if (popover.style.getPropertyValue('box-sizing') !== 'border-box') {
      popover.style.setProperty('box-sizing', 'border-box', 'important');
    }

    const currentShift = parseFloat(popover.style.getPropertyValue('--etrusted-horizontal-shift')) || 0;
    const rect = popover.getBoundingClientRect();
    const baseLeft = rect.left - currentShift;
    const isMobile = availableWidth <= mobileBreakpoint;
    const targetLeft = isMobile
      ? (availableWidth - rect.width) / 2
      : Math.min(Math.max(baseLeft, gutter), availableWidth - gutter - rect.width);
    const nextShift = targetLeft - baseLeft;
    const nextShiftValue = `${nextShift}px`;

    if (popover.style.getPropertyValue('--etrusted-horizontal-shift') !== nextShiftValue) {
      popover.style.setProperty('--etrusted-horizontal-shift', nextShiftValue, 'important');
    }
  }

  function observeHost(host) {
    const root = host.shadowRoot;
    if (!root || observedRoots.has(root)) return;

    observedRoots.add(root);
    const style = document.createElement('style');
    style.textContent = '.popover { translate: var(--etrusted-horizontal-shift, 0px) 0 !important; }';
    root.append(style);

    const observer = new MutationObserver(() => alignPopover(root));
    observer.observe(root, { attributes: true, attributeFilter: ['class', 'style'], childList: true, subtree: true });
    alignPopover(root);
  }

  function scan() {
    document.querySelectorAll(hostSelector).forEach(observeHost);
  }

  const documentObserver = new MutationObserver(scan);
  documentObserver.observe(document.documentElement, { childList: true, subtree: true });
  scan();

  let scheduled = false;
  const realign = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      document.querySelectorAll(hostSelector).forEach((host) => {
        if (host.shadowRoot) alignPopover(host.shadowRoot);
      });
    });
  };

  window.addEventListener('resize', realign, { passive: true });
  window.addEventListener('scroll', realign, { passive: true, capture: true });
  if (window.customElements) {
    customElements.whenDefined(hostSelector).then(scan);
  }
})();
